import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ConfigProvider, App as AntdApp } from 'antd'
import { getThemeColors } from '../configs/theme.colors'
import { getAntdThemeConfig } from './antd.theme.config'
import AntdStaticFunctionHolder from '../components/common/AntdStaticFunctionHolder'

/**
 * ThemeProvider Component
 * 
 * Centralized theme management for the application.
 * Handles:
 * - CSS custom properties injection
 * - Ant Design theme configuration
 * - Theme mode state management
 */
export const ThemeProvider = ({ children }) => {
    const themeMode = useSelector(state => state.theme?.mode || 'light')
    const colors = getThemeColors(themeMode)

    // Inject CSS custom properties for use in SCSS files
    useEffect(() => {
        const root = document.documentElement
        root.setAttribute('data-theme', themeMode)
        
        // Set CSS variables from centralized color config
        root.style.setProperty('--main-bg', colors.mainBg)
        root.style.setProperty('--second-bg', colors.secondBg)
        root.style.setProperty('--txt-color', colors.text)
        root.style.setProperty('--secondary-text', colors.secondaryText)
        root.style.setProperty('--txt-white', colors.txtWhite)
        root.style.setProperty('--sense-color', colors.senseColor)
        root.style.setProperty('--primary-color', colors.primary)
        root.style.setProperty('--primary-color-onclick', colors.primaryOnClick)
        root.style.setProperty('--success-color', colors.success)
        root.style.setProperty('--success-bg-color', colors.successBg)
        root.style.setProperty('--warning-color', colors.warning)
        root.style.setProperty('--warning-bg-color', colors.warningBg)
        root.style.setProperty('--error-color', colors.error)
        root.style.setProperty('--error-bg-color', colors.errorBg)
        root.style.setProperty('--box-shadow', colors.boxShadow)
        root.style.setProperty('--border-color', colors.borderColor)
        root.style.setProperty('--breadcrumb-text', colors.breadcrumbText)
    }, [themeMode, colors])

    return (
        <ConfigProvider theme={getAntdThemeConfig(themeMode, colors)}>
            <AntdApp>
                <AntdStaticFunctionHolder />
                {children}
            </AntdApp>
        </ConfigProvider>
    )
}
